import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { HistoryStore } from '@iotv/datamodel';
import { useMemo, useState } from 'react';
import ObjectHistoryStatistics from '../../generic/ObjectHistoryStatistics';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ObjectHistoryStatisticsWidget = (props) => {
    const [historyStore] = useState(new HistoryStore());
    const component = useMemo(() => (props.contextCustomer ? _jsx(ObjectHistoryStatistics, { context: { contextObject: props.contextCustomer, historyStore } }) : _jsx(_Fragment, {})), [props.contextCustomer, historyStore]);
    return {
        name: 'ObjectHistoryStatistics',
        category: 'generic',
        component,
    };
};
